<template>
  <div class="streaming_box">
    <div id="container" class="ccontainer"></div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import cameraList from '../utils/configs/cameraList'
export default {
  components: {},
  data() {
    return {
      cameraList: cameraList,
    }
  },
  methods: {
    ...mapMutations(['setAppinstance']),
    init() {
      window.appInstance = new TGApp.App()
      window.appInstance.initScene({
        container: document.getElementById('container'),
        mode: 'streaming3',
        url: streamingConfig.url,
        token: streamingConfig.token,
        resolution: [streamingConfig.width, streamingConfig.height],
        isShareToken: false,
      })
    },
  },
  computed: {},
  mounted() {
    this.init()
  },
  destroyed() {
    window.appInstance.uniCall('destroy')
  },
}
</script>
<style lang="less" scoped>
.streaming_box {
  width: 100%;
  height: 100%;
}
#container {
  width: 100%;
  height: 100%;
}
</style>
